export default {
  headerContent: {
    title: 'Tamamlayıcı Sağlık Sigortası',
    slogan: "Tamamlayıcı Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'TAMAMLAYICI SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Groupama Sigorta Tamamlayıcı Sağlık Sigortası',
    description: {
      title: 'Groupama Sigorta Tamamlayıcı Sağlık Sigortası Nedir? ',
      content: [
        'Seyahat sağlık sigortası, bireyin yurt içine veya yurt dışına iş, öğrenim veya tatil gibi nedenlerle yapacağı seyahatlere karşı teminat sunan sigorta ürünüdür.',
        'Yurt dışına bir seyahat planlarken, ihtiyaçlarınız için ne tür bir seyahat sağlık sigortasının uygun olduğunu göz önünde bulundurmanız her zaman tavsiye edilir.'
      ]
    },
    subContent: {
      title: 'Groupama Sigorta Yurt İçi Seyahat Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Gropama Yurt İçi Seyahat Sağlık Sigortası ile ülkemizde yapacağınız yolculuklarınız güvence altına alınır. Seyahat durumlarında beklenmedik olaylar sonucunda ihtiyaç duyacağınız hastalık veya kaza sonucu meydana gelebilecek masraflar poliçe limitleri kapsamında karşılanır.',
          subList: null
        },
        {
          paragraph:
            '**Türkiye ve KKTC sınırları içinde tüm seyahatlerinizde geçerlidir ve acil durumlarda devreye girer.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Tamamlayıcı Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Groupama Sigorta Tamamlayıcı Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
